import { Controller } from "@hotwired/stimulus"

// Controller to manage loading states with fallback messages if loading takes too long
export default class extends Controller {
  static targets = ["spinner", "fallback"]
  static classes = ["loading", "loaded"]

  connect() {
    // Add a timeout to show fallback message if loading takes too long (e.g., 5 seconds)
    this.timeout = setTimeout(() => {
      this.spinnerTargets.forEach(el => el.classList.add("hidden"));
      this.fallbackTargets.forEach(el => el.classList.remove("hidden"));
    }, 5000);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
